import ItemWhModal from '../Modal/ItemWhModal';
import { formatCurrency } from '../../../utils/SamuiUtils';

const formatNumericInput = (raw) => {
  if (raw === null || raw === undefined) return "";
  const cleaned = String(raw).replace(/,/g, "");
  if (cleaned === "") return "";
  if (!/^\d*\.?\d*$/.test(cleaned)) return null;
  const [intPart = "", decPart] = cleaned.split(".");
  const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (decPart !== undefined) {
    const decTrim = decPart.slice(0, 2);
    return `${intFmt}.${decTrim}`;
  }
  return intFmt;
};

const handleArrowNav = (e) => {
  if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
  const allInputs = Array.from(document.querySelectorAll("[data-nav-input]"));
  const idx = allInputs.indexOf(e.currentTarget);
  if (idx === -1) return;
  const next = e.key === "ArrowDown" ? allInputs[idx + 1] : allInputs[idx - 1];
  if (next) {
    e.preventDefault();
    next.focus();
    next.select();
  }
};

const onlyNumberKeyDown = (e) => {
  handleArrowNav(e);
  if (e.defaultPrevented) return;

  const { key, ctrlKey, metaKey } = e;
  if (ctrlKey || metaKey) return;

  const allowNav = new Set([
    "Backspace",
    "Delete",
    "Tab",
    "Enter",
    "Escape",
    "Home",
    "End",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
  ]);
  if (allowNav.has(key)) return;

  if (/[0-9]/.test(key)) {
    const el = e.currentTarget;
    const v = el?.value ?? "";
    const dotIdx = v.indexOf(".");
    if (dotIdx !== -1) {
      const { selectionStart, selectionEnd } = el;
      const decLen = v.length - dotIdx - 1;
      const isCursorAfterDot =
        typeof selectionStart === "number" &&
        typeof selectionEnd === "number" &&
        selectionStart === selectionEnd &&
        selectionStart > dotIdx;
      if (isCursorAfterDot && decLen >= 2) {
        e.preventDefault();
        return;
      }
    }
    return;
  }
  if (key === ",") return;
  if (key === ".") {
    const el = e.currentTarget;
    const v = el?.value ?? "";
    const hasDot = v.includes(".");
    if (!hasDot) return;
    const dotIdx = v.indexOf(".");
    const { selectionStart, selectionEnd } = el;
    const coversDot =
      typeof selectionStart === "number" &&
      typeof selectionEnd === "number" &&
      selectionStart <= dotIdx &&
      dotIdx < selectionEnd;
    if (!coversDot) e.preventDefault();
    return;
  }
  e.preventDefault();
};

const formatStockOnHand = (value) => {
  const normalized = Number(String(value ?? 0).replace(/,/g, ""));
  return formatCurrency(Number.isFinite(normalized) ? normalized : 0);
};

const ItemWhTable = ({
  mode,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  formDetailList,
  handleItemShow,
  handleQuantityChange,
  handleFocus,
  handleBlur,
  handleRemoveRow,
  disabled,
  whDataList = [],
  allOnhandData = [],
  onWhChangePerRow,
  globalWarehouse,
  onGlobalWarehouseChange,
}) => {
  const isCountPage = window.location.pathname === '/stock/stock-form-count';
  return (
    <div className="card">
      {isCountPage && (
        <style>{`
          .count-readonly-black,
          .count-readonly-black:disabled {
            color: #000 !important;
            -webkit-text-fill-color: #000 !important;
            opacity: 1 !important;
          }
        `}</style>
      )}
      <div className="card-header d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-3">
          <h4 className="card-title mb-0">รายละเอียดสินค้า</h4>
          {mode === 'FA' && (
            <div className="d-flex align-items-center gap-2">
              <label className="mb-0 text-nowrap" style={{ fontSize: 14 }}>คลังหลัก :</label>
              <select
                className="form-select form-select-sm"
                value={globalWarehouse || ""}
                onChange={(e) => onGlobalWarehouseChange && onGlobalWarehouseChange(e.target.value)}
                style={{ minWidth: 160 }}
                disabled={disabled}
              >
                <option value="">เลือกคลัง</option>
                {whDataList.map((wh) => (
                  <option key={wh.WH_Id} value={wh.WH_Id}>{wh.WH_Name}</option>
                ))}
              </select>
            </div>
          )}
        </div>
        <button
          hidden={window.location.pathname === '/product-delivery' ? true : false}
          className="btn text-white mx-3"
          onClick={handleItemShow}
          style={{
            backgroundColor: 'rgb(239, 108, 0)',
            whiteSpace: 'nowrap',
            padding: '10px',
            fontSize: '15px'
          }}
          disabled={disabled}
        >
          <i className="fa fa-plus"></i> เพิ่มรายการ
        </button>
      </div>
      <ItemWhModal
        formDetailList={formDetailList}
        showItemModal={showItemModal}
        handleItemClose={handleItemClose}
        itemDataList={itemDataList}
        onRowSelectItem={onRowSelectItem}
      />
      <div className="card-body">
        <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          <table id="basic-datatables" className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th className="text-center" style={{ width: '2%' }}>#</th>
                {(mode === 'FA' || mode === 'WDP') && <th className="text-center" style={{ width: '12%' }}>คลัง</th>}
                <th className="text-center" style={{ width: '8%' }}>รหัสสินค้า</th>
                <th
                  className="text-center"
                  style={(mode === 'FA' || mode === 'WDP') ? { width: '20%' } : { width: '25%' }}
                >
                  ชื่อสินค้า
                </th>
                <th className="text-center" style={{ width: '5%' }}>หน่วย</th>
                {!isCountPage && <th className="text-center" style={{ width: '10%' }}>Todo</th>}
                <th className="text-center" style={{ width: '10%' }}>จำนวนคงคลัง</th>

                {window.location.pathname === '/product-delivery' && (
                  <>
                    <th className="text-center" style={{ width: '10%' }}>จำนวนใบขาย</th>
                    <th className="text-center" style={{ width: '10%' }}>จำนวนค้างส่ง</th>
                  </>
                )}

                {mode === 'FA' ? (
                  <>
                    <th className="text-center" style={{ width: '10%' }}>เพิ่ม</th>
                    <th className="text-center" style={{ width: '10%' }}>ลด</th>
                  </>
                ) : (
                  <th className="text-center" style={{ width: '10%' }}>จำนวน{window.location.pathname === '/picking-list'
                    || window.location.pathname === '/bill-of-lading' ? 'เบิก'
                    : isCountPage ? 'ที่นับได้' : ''}</th>
                )}
                {isCountPage && (
                  <>
                    <th className="text-center" style={{ width: '10%' }}>Todo</th>
                    <th className="text-center" style={{ width: '10%' }}>ปรับตามจริง</th>
                  </>
                )}

                {window.location.pathname !== '/product-delivery' && (
                  <th className="text-center" style={{ width: '10%' }}>จำนวนคงเหลือ</th>
                )}

                <th className="text-center" style={{ width: '5%' }}>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {formDetailList.length > 0 ? (
                formDetailList.map((item, index) => (
                  <tr key={item.itemId || index + 1}>
                    {/* # */}
                    <td className="text-center">{index + 1}</td>

                    {/* คลัง */}
                    {(mode === 'FA' || mode === 'WDP') && (() => {
                      const hasAnyOnhandHistory = allOnhandData.some(
                        (oh) => Number(oh.Item_Id) === Number(item.itemId)
                      );
                      const filteredWhs = hasAnyOnhandHistory
                        ? whDataList.filter((wh) =>
                            Number(wh.WH_Id) === Number(item.fWhId) ||
                            allOnhandData.some(
                              (oh) => Number(oh.Item_Id) === Number(item.itemId) && Number(oh.WH_Id) === Number(wh.WH_Id)
                            )
                          )
                        : whDataList;
                      return (
                        <td className="text-center">
                          {filteredWhs.length === 1 ? (
                            <span>{filteredWhs[0].WH_Name}</span>
                          ) : (
                            <select
                              className="form-select form-select-sm"
                              value={item.fWhId || ""}
                              onChange={(e) => onWhChangePerRow && onWhChangePerRow(index, e.target.value)}
                              style={{ minWidth: 100 }}
                              disabled={disabled}
                            >
                              <option value="">เลือกคลัง</option>
                              {filteredWhs.map((wh) => (
                                <option key={wh.WH_Id} value={wh.WH_Id}>{wh.WH_Name}</option>
                              ))}
                            </select>
                          )}
                        </td>
                      );
                    })()}

                    {/* รหัสสินค้า */}
                    <td className="text-center">
                      <span>{item.itemCode || ''}</span>
                    </td>

                    {/* ชื่อสินค้า */}
                    <td className="text-left">
                      <span>{item.itemName || ''}</span>
                    </td>

                    {/* หน่วย */}
                    <td className="text-center">
                      <span>{item.itemUnit || ''}</span>
                    </td>

                    {/* Todo */}
                    {!isCountPage && (
                      <td className="text-center">
                        <span>{item.docType || ''}</span>
                      </td>
                    )}

                    {/* จำนวนคงคลัง */}
                    <td className="text-center">
                      <span>{formatStockOnHand(item.itemOnHand)}</span>
                    </td>

                    {window.location.pathname === '/product-delivery' && (
                      <>
                        <td className="text-center">
                          <span>{formatCurrency(item.itemQty || 0)}</span>
                        </td>
                        <td className="text-center">
                          <span>{formatCurrency(item.itemRecQty || 0)}</span>
                        </td>
                      </>
                    )}

                    {mode === 'FA' ? (
                      <>
                        {/* เพิ่ม */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            data-nav-input="true"
                            value={item.itemIncrease !== null && item.itemIncrease !== undefined && item.itemIncrease !== '' ? item.itemIncrease : '0.00'}
                            onChange={(e) => {
                              const formatted = formatNumericInput(e.target.value);
                              if (formatted !== null) {
                                handleQuantityChange(index, 'increase', formatted, item.itemOnHand);
                              }
                            }}
                            onFocus={(e) => {
                              handleFocus(index, 'itemIncrease');
                              const t = e.target;
                              requestAnimationFrame(() => { t.select(); });
                            }}
                            onBlur={(e) => handleBlur(index, 'itemIncrease', e.target.value)}
                            onKeyDown={onlyNumberKeyDown}
                          />
                        </td>

                        {/* ลด */}
                        <td className="text-center">
                          <input
                            type="text"
                            className="form-control text-center"
                            data-nav-input="true"
                            value={item.itemDecrease !== null && item.itemDecrease !== undefined && item.itemDecrease !== '' ? item.itemDecrease : '0.00'}
                            onChange={(e) => {
                              const formatted = formatNumericInput(e.target.value);
                              if (formatted !== null) {
                                handleQuantityChange(index, 'decrease', formatted, item.itemOnHand);
                              }
                            }}
                            onFocus={(e) => {
                              handleFocus(index, 'itemDecrease');
                              const t = e.target;
                              requestAnimationFrame(() => { t.select(); });
                            }}
                            onBlur={(e) => handleBlur(index, 'itemDecrease', e.target.value)}
                            onKeyDown={onlyNumberKeyDown}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        {/* จำนวน / จำนวนที่นับได้ */}
                        <td className="text-center">
                          <input
                            type="text"
                            className={`form-control text-center ${isCountPage ? "count-readonly-black" : ""}`.trim()}
                            data-nav-input="true"
                            value={isCountPage ? formatStockOnHand(item.itemCounted) : (item.itemDecrease || "")}
                            onChange={(e) => {
                              const formatted = formatNumericInput(e.target.value);
                              if (formatted !== null) {
                                handleQuantityChange(index, isCountPage ? 'count' : 'decrease', formatted, item.itemOnHand);
                              }
                            }}
                            onFocus={(e) => {
                              isCountPage ? handleFocus(index, 'itemCounted') : handleFocus(index);
                              const t = e.target;
                              requestAnimationFrame(() => t.select());
                            }}
                            onBlur={(e) => isCountPage ? handleBlur(index, 'itemCounted', e.target.value) : handleBlur(index)}
                            onKeyDown={onlyNumberKeyDown}
                            disabled={
                              disabled ||
                              (window.location.pathname === '/icebox' ? true : false)
                            }
                          />
                        </td>
                        {isCountPage && (
                          <>
                            <td className="text-center">
                              <span style={{ color: item.docType === 'AI' ? 'green' : item.docType === 'AO' ? '#E13F57' : '#111' }}>
                                {item.docType === 'AI' ? 'ปรับเพิ่ม' : item.docType === 'AO' ? 'ปรับลด' : 'เท่าเดิม'}
                              </span>
                            </td>
                            <td className="text-center">
                              <span style={{ fontWeight: 600, color: item.docType === 'AI' ? 'green' : item.docType === 'AO' ? '#E13F57' : '#111' }}>
                                {item.docType === 'AI' ? `+${formatStockOnHand(item.itemQty)}` : item.docType === 'AO' ? `-${formatStockOnHand(item.itemQty)}` : '-'}
                              </span>
                            </td>
                          </>
                        )}
                      </>
                    )}

                    {/* จำนวนคงเหลือ */}
                    {window.location.pathname !== '/product-delivery' && (
                      <td className="text-center">
                        <span>{formatCurrency(item.itemBalance) || 0}</span>
                      </td>
                    )}

                    {/* ลบ */}
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-danger"
                        disabled={disabled}
                        onClick={() => handleRemoveRow(index)}>
                        ลบ
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="99">
                    <center>
                      <h5>ไม่พบรายการสินค้า</h5>
                    </center>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div >
  );
};

export default ItemWhTable;